import LegalDocumentPage from "./LegalDocumentPage";

export default function ClearTerms() {
  return <LegalDocumentPage documentKey="payments" />;
}
